import constants from 'utils/constants'

export const getTipoVestigioLabel = (identificador) => {
  switch (identificador) {
    case 'GERAL':
      return 'Geral'
    case 'BIOLOGICO':
      return 'Biológico'
    case 'BALISTICO':
      return 'Balístico'
    case 'ELETRONICO':
      return 'Eletrônico'
    case 'PAPILOSCOPICO':
      return 'Papiloscópico'
    case 'DOCUMENTAL':
      return 'Documental'
    case 'QUIMICO':
      return 'Químico-toxicológico'
    case 'MERCEOLOGICO':
      return 'Merceológico'
    case 'DIGITAL':
      return 'Digital'

    default:
      return ''
  }
}

export const getLabelStatusCadeiaDeCustodia = (status) => {
  switch (status) {
    case 'GUARDADO':
      return 'Guardado'
    case 'ENCAMINHADO':
      return 'Encaminhado'
    case 'DESCARTADO':
      return 'Descartado'
    case 'COM_USUARIO':
      return 'Com usuário'
    case 'EM_PASSAGEM_CUSTODIA':
      return 'Em passagem de custódia'
    case 'DESMEMBRADO':
      return 'Desmembrado'
    case 'CONSUMIDO':
      return 'Consumido'
    default:
      return 'Indefinido'
  }
}

export const getStatusCadeiaCustodiaVestigio = (vestigio) => {
  if (vestigio.emClassificacao) {
    return 'Em classificação'
  }
  return getLabelStatusCadeiaDeCustodia(vestigio.statusCadeiaCustodia)
}

export const getLabelEstado = (rowData) => {
  switch (rowData.status) {
    case 'PENDENTE': {
      return 'PENDENTE'
    }
    case 'LIBERADO': {
      return 'LIBERADO'
    }
    case 'ENTREGUE': {
      return 'ENTREGUE'
    }
    default:
      return '-'
  }
}

export const getLabelClassificacaoCadaver = (classificacao) => {
  switch (classificacao) {
    case 'NAO_IDENTIFICADO':
      return 'NÃO IDENTIFICADO'
    case 'IDENTIFICADO':
      return 'IDENTIFICADO'
    case 'NECROPAPILOSCOPICO_POSITIVO':
      return 'EXAME NECROPAPILOSCÓPICO POSITIVO'
    case 'RECONHECIDO':
      return 'RECONHECIDO'
    default:
      return '-'
  }
}

export const getLabelMetodoIdentificacaoCadaver = (metodoIdentificacao) => {
  switch (metodoIdentificacao) {
    case 'NECROPAPILOSCOPIA':
      return 'NECROPAPILOSCOPIA'
    case 'DNA':
      return 'DNA'
    case 'ODONTOLOGIA':
      return 'ODONTOLOGIA'
    case 'ANTROPOLOGIA':
      return 'ANTROPOLOGIA'
    case 'RECONHECIMENTO':
      return 'RECONHECIMENTO'
    case 'ODONTOLOGIA':
      return 'ODONTOLOGIA'
    default:
      return ''
  }
}

export const getLabelResultadoExameNecropapiloscopicoCadaver = (classificacao) => {
  switch (classificacao) {
    case 'IDENTIFICADO_DOCUMENTO':
      return 'Confronto com documento disponibilizado (IDENTIFICADO)'
    case 'NAO_IDENTIFICADO_DOCUMENTO':
      return 'Confronto com documento disponibilizado (NÃO IDENTIFICADO)'
    case 'IDENTIFICADO_SISTEMA':
      return 'Busca no sistema VSOFT (IDENTIFICADO)'
    case 'NAO_IDENTIFICADO_SISTEMA':
      return 'Busca no sistema VSOFT (NÃO IDENTIFICADO)'
    case 'NAO_IDENTIFICADO_FALTA_DOCUMENTO':
      return 'Não identificado por falta de documento'
    case 'NAO_IDENTIFICADO_SEM_IMPRESSAO_PAPILAR':
      return 'Não identificado por impossibilidade de extração de impressão papilar'
  }
}

export const getLabelEndereco = (option) =>
  `${option.rua}${option.numero ? `, ${option.numero}` : ''}${option.complemento ? `, ${option.complemento}` : ''}, ${option.cidade} - ${option.estado}. ${option.latitudeGps && option.longitudeGps ? `Latitude: ${option.latitudeGps}; Longitude: ${option.longitudeGps}` : ''}`

export const getLabelGrauRelacaoCadaver = (grauRelacao) => {
  switch (grauRelacao) {
    case 'PARENTE_LINHA_RETA': {
      return 'PARENTE EM LINHA RETA'
    }
    case 'CONJUGE_COMPANHEIRO': {
      return 'CÔNJUGE OU COMPANHEIRO'
    }
    case 'PARENTE_LINHA_COLATERAL': {
      return 'PARENTE EM LINHA COLATERAL ATÉ O QUARTO GRAU'
    }
    case 'ENTIDADE_LONGA_PERMANENCIA': {
      return 'ADMINISTRADOR, DIRETOR OU GERENTE DE ENTIDADE DE LONGA PERMANÊNCIA OU INSTITUIÇÃO CONGÊNERE'
    }
    case 'TRABALHO_AMIZADE_VIZINHANCA': {
      return 'RELAÇÃO DE TRABALHO, AMIZADE OU VIZINHANÇA COM O FINADO OU ASSISTIDO AOS SEUS ÚLTIMOS MOMENTOS'
    }
    case 'NENHUMA': {
      return 'NENHUMA RELAÇÃO DE AFINIDADE OU GRAU DE PARENTESCO COM O FINADO'
    }
    default:
      return ''
  }
}

export const getLabelRegiaoAnatomica = (regiao) => {
  switch (regiao) {
    case 'CERVICAL':
      return 'Cervical'
    case 'OCCIPITAL':
      return 'Occipital'
    case 'AURICULAR_ESQUERDA':
      return 'Auricular esquerda'
    case 'AURICULAR_DIREITA':
      return 'Auricular direita'
    case 'TEMPORAL_ESQUERDA':
      return 'Temporal esquerda'
    case 'TEMPORAL_DIREITA':
      return 'Temporal direita'
    case 'PARIETAL_ESQUERDA':
      return 'Parietal esquerda'
    case 'PARIETAL_DIREITA':
      return 'Parietal direita'
    case 'QUINTO_QUIRODACTILO_ESQUERDO':
      return 'Quinto quirodactilo esquerdo'
    case 'QUARTO_QUIRODACTILO_ESQUERDO':
      return 'Quarto quirodactilo esquerdo'
    case 'TERCEIRO_QUIRODACTILO_ESQUERDO':
      return 'Terceiro quirodactilo esquerdo'
    case 'SEGUNDO_QUIRODACTILO_ESQUERDO':
      return 'Segundo quirodactilo esquerdo'
    case 'PRIMEIRO_QUIRODACTILO_ESQUERDO':
      return 'Primeiro quirodactilo esquerdo'
    case 'DORSAL_MAO_ESQUERDA':
      return 'Dorsal da mão esquerda'
    case 'POSTERIOR_PUNHO_ESQUERDO':
      return 'Posterior do punho esquerdo'
    case 'POSTERIOR_TERCO_INFERIOR_ANTEBRACO_ESQUERDO':
      return 'Posterior do terço inferior do antebraço esquerdo'
    case 'POSTERIOR_TERCO_MEDIO_ANTEBRACO_ESQUERDO':
      return 'Posterior do terço médio do antebraço esquerdo'
    case 'POSTERIOR_TERCO_SUPERIOR_ANTEBRACO_ESQUERDO':
      return 'Posterior do terço superior do antebraço esquerdo'
    case 'COTOVELO_ESQUERDO':
      return 'Cotovelo esquerdo'
    case 'POSTERIOR_TERCO_INFERIOR_BRACO_ESQUERDO':
      return 'Posterior do terço inferior do braço esquerdo'
    case 'POSTERIOR_TERCO_MEDIO_BRACO_ESQUERDO':
      return 'Posterior do terço médio do braço esquerdo'
    case 'POSTERIOR_TERCO_SUPERIOR_BRACO_ESQUERDO':
      return 'Posterior do terço superior braço esquerdo'
    case 'POSTERIOR_DELTOIDIANA_ESQUERDA':
      return 'Posterior da deltoidiana esquerda'
    case 'QUINTO_QUIRODACTILO_DIREITO':
      return 'Quinto quirodactilo direito'
    case 'QUARTO_QUIRODACTILO_DIREITO':
      return 'Quarto quirodactilo direito'
    case 'TERCEIRO_QUIRODACTILO_DIREITO':
      return 'Terceiro quirodactilo direito'
    case 'SEGUNDO_QUIRODACTILO_DIREITO':
      return 'Segundo quirodactilo direito'
    case 'PRIMEIRO_QUIRODACTILO_DIREITO':
      return 'Primeiro quirodactilo direito'
    case 'DORSAL_MAO_DIREITA':
      return 'Dorsal da mão direita'
    case 'POSTERIOR_PUNHO_DIREITO':
      return 'Posterior do punho direito'
    case 'POSTERIOR_TERCO_INFERIOR_ANTEBRACO_DIREITO':
      return 'Posterior do terço inferior do antebraço direito'
    case 'POSTERIOR_TERCO_MEDIO_ANTEBRACO_DIREITO':
      return 'Posterior do terço médio do antebraço direito'
    case 'POSTERIOR_TERCO_SUPERIOR_ANTEBRACO_DIREITO':
      return 'Posterior do terço superior do antebraço direito'
    case 'COTOVELO_DIREITO':
      return 'Cotovelo direito'
    case 'POSTERIOR_TERCO_INFERIOR_BRACO_DIREITO':
      return 'Posterior do terço inferior do braço direito'
    case 'POSTERIOR_TERCO_MEDIO_BRACO_DIREITO':
      return 'Posterior do terço médio do braço direito'
    case 'POSTERIOR_TERCO_SUPERIOR_BRACO_DIREITO':
      return 'Posterior do terço superior do antebraço direito'
    case 'POSTERIOR_DELTOIDIANA_DIREITA':
      return 'Posterior da deltoidiana direita'
    case 'ILIACA_DIREITA':
      return 'Ilíaca direita'
    case 'ILIACA_ESQUERDA':
      return 'Ilíaca esquerda'
    case 'LOMBAR_DIREITA':
      return 'Lombar direita'
    case 'LOMBAR_ESQUERDA':
      return 'Lombar esquerda'
    case 'DORSAL_DIREITA':
      return 'Dorsal direita'
    case 'DORSAL_ESQUERDA':
      return 'Dorsal esquerda'
    case 'ESCAPULAR_DIREITA':
      return 'Escapular direita'
    case 'ESCAPULAR_ESQUERDA':
      return 'Escapular esquerda'
    case 'SACROCOCCIGIANA':
      return 'Sacrococcigiana'
    case 'ESPONDILIANA':
      return 'Espondiliana'
    case 'SUPRA_ESCAPULAR_ESQUERDA':
      return 'Supra-escapular esquerda'
    case 'SUPRA_ESCAPULAR_DIREITA':
      return 'Supra-escapular direita'
    case 'BORDA_EXTERNA_PE_ESQUERDO':
      return 'Borda externa do pé esquerdo'
    case 'CALCANEANA_ESQUERDA':
      return 'Calcaneana esquerda'
    case 'MALEOLAR_EXTERNA_ESQUERDA':
      return 'Maleolar externa esquerda'
    case 'POSTERIOR_TERCO_INFERIOR_PERNA_ESQUERDA':
      return 'Posterior do terço inferior da perna esquerda'
    case 'POSTERIOR_TERCO_MEDIO_PERNA_ESQUERDA':
      return 'Posterior do terço médio da perna esquerda'
    case 'POSTERIOR_TERCO_SUPERIOR_PERNA_ESQUERDA':
      return 'Posterior do terço superior da perna esquerda'
    case 'POPLITEA_ESQUERDA':
      return 'Poplítea esquerda'
    case 'POSTERIOR_TERCO_INFERIOR_COXA_ESQUERDA':
      return 'Posterior do terço inferior da coxa esquerda'
    case 'POSTERIOR_TERCO_MEDIO_COXA_ESQUERDA':
      return 'Posterior do terço médio da coxa esquerda'
    case 'POSTERIOR_TERCO_SUPERIOR_COXA_ESQUERDA':
      return 'Posterior do terço superior da coxa esquerda'
    case 'GLUTEA_ESQUERDA':
      return 'Glútea esquerda'
    case 'BORDA_EXTERNA_PE_DIREITO':
      return 'Borda externa do pé direito'
    case 'CALCANEANA_DIREITA':
      return 'Calcaneana direita'
    case 'MALEOLAR_EXTERNA_DIREITA':
      return 'Maleolar externa direita'
    case 'POSTERIOR_TERCO_INFERIOR_PERNA_DIREITA':
      return 'Posterior do terço inferior da perna direita'
    case 'POSTERIOR_TERCO_MEDIO_PERNA_DIREITA':
      return 'Posterior do terço médio da perna direita'
    case 'POSTERIOR_TERCO_SUPERIOR_PERNA_DIREITA':
      return 'Posterior do terço superior da perna direita'
    case 'POPLITEA_DIREITA':
      return 'Poplítea direita'
    case 'POSTERIOR_TERCO_INFERIOR_COXA_DIREITA':
      return 'Posterior do terço inferior da coxa direita'
    case 'POSTERIOR_TERCO_MEDIO_COXA_DIREITA':
      return 'Posterior do terço médio da coxa direita'
    case 'POSTERIOR_TERCO_SUPERIOR_COXA_DIREITA':
      return 'Posterior do terço superior da coxa direita'
    case 'GLUETEA_DIREITA':
      return 'Glútea direita'
    case 'INFRA_HIOIDIANA':
      return 'Infra-hioidiana'
    case 'SUPRA_HIOIDIANA':
      return 'Supra-hioidiana'
    case 'CAROTIDIANA_ESQUERDA':
      return 'Carotidiana esquerda'
    case 'CAROTIDIANA_DIREITA':
      return 'Carotidiana direita'
    case 'MENTONIANA':
      return 'Mentoniana'
    case 'BUCINADORA_ESQUERDA':
      return 'Bucinadora esquerda'
    case 'BUCINADORA_DIREITA':
      return 'Bucinadora direita'
    case 'MASSETERIANA_ESQUERDA':
      return 'Masseteriana esquerda'
    case 'MASSETERIANA_DIREITA':
      return 'Masseteriana direita'
    case 'LABIAL':
      return 'Labial'
    case 'MALAR_ESQUERDA':
      return 'Malar esquerda'
    case 'MALAR_DIREITA':
      return 'Malar direita'
    case 'NASAL':
      return 'Nasal'
    case 'ZIGOMATICA_ESQUERDA':
      return 'Zigomática esquerda'
    case 'ZIGOMATICA_DIREITA':
      return 'Zigomática direita'
    case 'ORBITAL_DIREITA':
      return 'Orbital direita'
    case 'ORBITAL_ESQUERDA':
      return 'Orbital esquerda'
    case 'FRONTAL':
      return 'Frontal'
    case 'HIPOTENAR_DIREITA':
      return 'Hipotenar direita'
    case 'CONCAVO_MAO_DIREITA':
      return 'Côncavo da mão direita'
    case 'TENAR_DIREITA':
      return 'Tenar direita'
    case 'INTERNA_PUNHO_DIREITO':
      return 'Interna do punho direito'
    case 'ANTERIOR_PUNHO_DIREITO':
      return 'Anterior do punho direito'
    case 'INTERNA_TERCO_INFERIOR_ANTEBRACO_DIREITO':
      return 'Interna do terço inferior do antebraço direito'
    case 'ANTERIOR_TERCO_INFERIOR_ANTEBRACO_DIREITO':
      return 'Anterior do terço inferior do antebraço direito'
    case 'INTERNA_TERCO_MEDIO_ANTEBRACO_DIREITO':
      return 'Interna do terço médio do antebraço direito'
    case 'ANTERIOR_TERCO_MEDIO_ANTEBRACO_DIREITO':
      return 'Anterior do terço médio do antebraço direito'
    case 'INTERNA_TERCO_SUPERIOR_ANTEBRACO_DIREITO':
      return 'Interna do terço superior do antebraço direito'
    case 'ANTERIOR_TERCO_SUPERIOR_ANTEBRACO_DIREITO':
      return 'Anterior do terço superior do antebraço direito'
    case 'INTERNA_PREGA_COTOVELO_DIREITO':
      return 'Interna da prega do cotovelo direito'
    case 'PREGA_COTOVELO_DIREITO':
      return 'Prega do cotovelo direito'
    case 'INTERNA_TERCO_INFERIOR_BRACO_DIREITO':
      return 'Interna do terço inferior do braço direito'
    case 'ANTERIOR_TERCO_INFERIOR_BRACO_DIREITO':
      return 'Anterior do terço inferior do braço direito'
    case 'INTERNA_TERCO_MEDIO_BRACO_DIREITO':
      return 'Interna do terço médio do braço direito'
    case 'ANTERIOR_TERCO_MEDIO_BRACO_DIREITO':
      return 'Anterior do terço médio do braço direito'
    case 'INTERNA_TERCO_SUPERIOR_BRACO_DIREITO':
      return 'Interna do terço superior do braço direito'
    case 'ANTERIOR_TERCO_SUPERIOR_BRACO_DIREITO':
      return 'Anterior do terço superior do braço direito'
    case 'DELTOIDIANA_DIREITA':
      return 'Deltoidiana direita'
    case 'TENAR_ESQUERDA':
      return 'Tenar esquerda'
    case 'CONCAVO_MAO_ESQUERDA':
      return 'Côncavo da mão esquerda'
    case 'HIPOTENAR_ESQUERDA':
      return 'Hipotenar esquerda'
    case 'INTERNA_PUNHO_ESQUERDO':
      return 'Interna do punho esquerdo'
    case 'ANTERIOR_PUNHO_ESQUERDO':
      return 'Anterior do punho esquerdo'
    case 'INTERNA_TERCO_INFERIOR_BRACO_ESQUERDO':
      return 'Interna do terço inferior do braço esquerdo'
    case 'INTERNA_TERCO_INFERIOR_ANTEBRACO_ESQUERDO':
      return 'Interna do terço inferior do antebraço esquerdo'
    case 'ANTERIOR_TERCO_INFERIOR_ANTEBRACO_ESQUERDO':
      return 'Anterior do terço inferior do antebraço esquerdo'
    case 'INTERNA_TERCO_MEDIO_ANTEBRACO_ESQUERDO':
      return 'Interna do terço médio do antebraço esquerdo'
    case 'ANTERIOR_TERCO_MEDIO_ANTEBRACO_ESQUERDO':
      return 'Anterior do terço médio do antebraço esquerdo'
    case 'INTERNA_TERCO_SUPERIOR_ANTEBRACO_ESQUERDO':
      return 'Interna do terço superior do antebraço esquerdo'
    case 'ANTERIOR_TERCO_SUPERIOR_ANTEBRACO_ESQUERDO':
      return 'Anterior do terço superior do antebraço esquerdo'
    case 'INTERNA_PREGA_COTOVELO_ESQUERDO':
      return 'Interna da prega do cotovelo esquerdo'
    case 'ANTERIOR_PREGA_COTOVELO_ESQUERDO':
      return 'Anterior da prega do cotovelo esquerdo'
    case 'ANTERIOR_TERCO_INFERIOR_BRACO_ESQUERDO':
      return 'Anterior do terço inferior do braço esquerdo'
    case 'INTERNA_TERCO_MEDIO_BRACO_ESQUERDO':
      return 'Interna do terço médio do braço esquerdo'
    case 'ANTERIOR_TERCO_MEDIO_BRACO_ESQUERDO':
      return 'Anterior do terço médio do braço esquerdo'
    case 'INTERNA_TERCO_SUPERIOR_BRACO_ESQUERDO':
      return 'Interna do terço superior do braço esquerdo'
    case 'ANTERIOR_TERCO_SUPERIOR_BRACO_ESQUERDO':
      return 'Anterior do terço superior do braço esquerdo'
    case 'DELTOIDIANA_ESQUERDA':
      return 'Deltoidiana esquerda'
    case 'ESCROTAL':
      return 'Escrotal'
    case 'PENIANA':
      return 'Peniana'
    case 'PUBIANA':
      return 'Pubiana'
    case 'INGUINAL_ESQUERDA':
      return 'Inguinal esquerda'
    case 'INGUINAL_DIREITA':
      return 'Inguinal direita'
    case 'FOSSA_ILIACA_ESQUERDA':
      return 'Fossa ilíaca esquerda'
    case 'FOSSA_ILIACA_DIREITA':
      return 'Fossa ilíaca direita'
    case 'HIPOGASTRICA':
      return 'Hipogástrica'
    case 'UMBILICAL':
      return 'Umbilical'
    case 'FLANCO_ESQUERDO':
      return 'Flanco esquerdo'
    case 'MESOGASTRICA':
      return 'Mesogástrica'
    case 'FLANCO_DIREITO':
      return 'Flanco direito'
    case 'HIPOCONDRIO_ESQUERDO':
      return 'Hipocôndrio esquerdo'
    case 'EPIGASTRICA':
      return 'Epigástrica'
    case 'HIPOCONDRIO_DIREITO':
      return 'Hipocôndrio direito'
    case 'HIPOCONDRIO_DIREITO_EXTERNO':
      return 'Hipocôndrio direito'
    case 'MAMILAR_ESQUERDA':
      return 'Mamilar esquerda'
    case 'MAMILAR_DIREITA':
      return 'Mamilar direita'
    case 'MAMARIA_ESQUERDA':
      return 'Mamária esquerda'
    case 'MAMARIA_DIREITA':
      return 'Mamária direita'
    case 'TORACICA_ESQUERDA':
      return 'Torácica esquerda'
    case 'TORACICA_ESQUERDA_EXTERNA':
      return 'Torácica esquerda'
    case 'TORACICA_DIREITA':
      return 'Torácica direita'
    case 'TORACICA_DIREITA_EXTERNA':
      return 'Torácica direita'
    case 'ESTERNAL':
      return 'Esternal'
    case 'INFRACLAVICULAR_ESQUERDA':
      return 'Infraclavicular esquerda'
    case 'INFRACLAVICULAR_DIREITA':
      return 'Infraclavicular direita'
    case 'CLAVICULAR_ESQUERDA':
      return 'Clavicular esquerda'
    case 'CLAVICULAR_DIREITA':
      return 'Clavicular direita'
    case 'SUPRACLAVICULAR_DIREITA':
      return 'Supraclavicular direita'
    case 'SUPRACLAVICULAR_ESQUERDA':
      return 'Supraclavicular esquerda'
    case 'QUINTO_PEDODACTILO_DIREITO':
      return 'Quinto pedodactilo direito'
    case 'QUARTO_PEDODACTILO_DIREITO':
      return 'Quarto pedodactilo direito'
    case 'TERCEIRO_PEDODACTILO_DIREITO':
      return 'Terceiro pedodactilo direito'
    case 'SEGUNDO_PEDODACTILO_DIREITO':
      return 'Segundo pedodactilo direito'
    case 'PRIMEIRO_PEDODACTILO_DIREITO':
      return 'Primeiro pedodactilo direito'
    case 'DORSAL_PE_DIREITO':
      return 'Dorsal do pé direito'
    case 'MALEOLAR_INTERNA_DIREITA':
      return 'Maleolar interna direita'
    case 'INTERNA_TERCO_INFERIOR_PERNA_DIREITA':
      return 'Interna do terço inferior da perna direita'
    case 'ANTERIOR_TERCO_INFERIOR_PERNA_DIREITA':
      return 'Anterior do terço inferior da perna direita'
    case 'INTERNA_TERCO_MEDIO_PERNA_DIREITA':
      return 'Interna do terço médio da perna direita'
    case 'ANTERIOR_TERCO_MEDIO_PERNA_DIREITA':
      return 'Anterior do terço médio da perna direita'
    case 'INTERNA_TERCO_SUPERIOR_PERNA_DIREITA':
      return 'Interna do terço superior da perna direita'
    case 'ANTERIOR_TERCO_SUPERIOR_PERNA_DIREITA':
      return 'Anterior do terço superior da perna direita'
    case 'ROTULIANA_DIREITA':
      return 'Rotuliana direita'
    case 'INTERNA_JOELHO_DIREITO':
      return 'Interna do joelho direito'
    case 'ANTERIOR_JOELHO_DIREITO':
      return 'Anterior do joelho direito'
    case 'INTERNA_TERCO_INFERIOR_COXA_DIREITA':
      return 'Interna do terço inferior da coxa direita'
    case 'ANTERIOR_TERCO_INFERIOR_COXA_DIREITA':
      return 'Anterior do terço inferior da coxa direita'
    case 'INTERNA_TERCO_MEDIO_COXA_DIREITA':
      return 'Interna do terço médio da coxa direita'
    case 'ANTERIOR_TERCO_MEDIO_COXA_DIREITA':
      return 'Anterior do terço médio da coxa direita'
    case 'INTERNA_TERCO_SUPERIOR_COXA_DIREITA':
      return 'Interna do terço superior da coxa direita'
    case 'ANTERIOR_TERCO_SUPERIOR_COXA_DIREITA':
      return 'Anterior do terço superior da coxa direita'
    case 'CRURAL_DIREITA':
      return 'Crural direita'
    case 'QUINTO_PEDODACTILO_ESQUERDO':
      return 'Quinto pedodactilo esquerdo'
    case 'QUARTO_PEDODACTILO_ESQUERDO':
      return 'Quarto pedodactilo esquerdo'
    case 'TERCEIRO_PEDODACTILO_ESQUERDO':
      return 'Terceiro pedodactilo esquerdo'
    case 'SEGUNDO_PEDODACTILO_ESQUERDO':
      return 'Segundo pedodactilo esquerdo'
    case 'PRIMEIRO_PEDODACTILO_ESQUERDO':
      return 'Primeiro pedodactilo esquerdo'
    case 'DORSAL_PE_ESQUERDO':
      return 'Dorsal do pé esquerdo'
    case 'MALEOLAR_INTERNA_ESQUERDA':
      return 'Maleolar interna esquerda'
    case 'INTERNA_TERCO_INFERIOR_PERNA_ESQUERDA':
      return 'Interna do terço inferior da perna esquerda'
    case 'ANTERIOR_TERCO_INFERIOR_PERNA_ESQUERDA':
      return 'Anterior do terço inferior da perna esquerda'
    case 'INTERNA_TERCO_MEDIO_PERNA_ESQUERDA':
      return 'Interna do terço médio da perna esquerda'
    case 'ANTERIOR_TERCO_MEDIO_PERNA_ESQUERDA':
      return 'Anterior do terço médio da perna esquerda'
    case 'INTERNA_TERCO_SUPERIOR_PERNA_ESQUERDA':
      return 'Interna do terço superior da perna esquerda'
    case 'ANTERIOR_TERCO_SUPERIOR_PERNA_ESQUERDA':
      return 'Anterior do terço superior da perna esquerda'
    case 'ROTULIANA_ESQUERDA':
      return 'Rotuliana esquerda'
    case 'INTERNA_JOELHO_ESQUERDO':
      return 'Interna do joelho esquerdo'
    case 'ANTERIOR_JOELHO_ESQUERDO':
      return 'Anterior do joelho esquerdo'
    case 'INTERNA_TERCO_INFERIOR_COXA_ESQUERDA':
      return 'Interna do terço inferior da coxa esquerda'
    case 'ANTERIOR_TERCO_INFERIOR_COXA_ESQUERDA':
      return 'Anterior do terço inferior da coxa esquerda'
    case 'INTERNA_TERCO_MEDIO_COXA_ESQUERDA':
      return 'Interna do terço médio da coxa esquerda'
    case 'ANTERIOR_TERCO_MEDIO_COXA_ESQUERDA':
      return 'Anterior do terço médio da coxa esquerda'
    case 'INTERNA_TERCO_SUPERIOR_COXA_ESQUERDA':
      return 'Interna do terço superior da coxa esquerda'
    case 'ANTERIOR_TERCO_SUPERIOR_COXA_ESQUERDA':
      return 'Anterior do terço superior da coxa esquerda'
    case 'CRURAL_ESQUERDA':
      return 'Crural esquerda'
    case 'LATERAL_PESCOCO_ESQUERDA':
      return 'Lateral esquerda do pescoço'
    case 'PALMAR_MAO_ESQUERDA':
      return 'Palmar da mão esquerda'
    case 'EXTERNA_PUNHO_ESQUERDO':
      return 'Externa do punho esquerdo'
    case 'EXTERNA_TERCO_INFERIOR_ANTEBRACO_ESQUERDO':
      return 'Externa do terço inferior do antebraço esquerdo'
    case 'EXTERNA_TERCO_MEDIO_ANTEBRACO_ESQUERDO':
      return 'Externa do terço médio do antebraço esquerdo'
    case 'EXTERNA_TERCO_SUPERIOR_ANTEBRACO_ESQUERDO':
      return 'Externa do terço superior do antebraço esquerdo'
    case 'EXTERNA_COTOVELO_ESQUERDO':
      return 'Externa do cotovelo esquerdo'
    case 'EXTERNA_TERCO_INFERIOR_BRACO_ESQUERDO':
      return 'Externa do terço inferior do braço esquerdo'
    case 'EXTERNA_TERCO_MEDIO_BRACO_ESQUERDO':
      return 'Externa do terço médio do braço esquerdo'
    case 'EXTERNA_TERCO_SUPERIOR_BRACO_ESQUERDO':
      return 'Externa do terço superior do braço esquerdo'
    case 'ESCAPULO_UMERAL_ESQUERDA':
      return 'Escápulo-umeral esquerda'
    case 'LATERAL_EXTERNA_PE_ESQUERDO':
      return 'Lateral externa do pé esquerdo'
    case 'MALEOLAR_ESQUERDA':
      return 'Maleolar esquerda'
    case 'EXTERNA_TERCO_INFERIOR_PERNA_ESQUERDA':
      return 'Externa do terço inferior da perna esquerda'
    case 'EXTERNA_TERCO_SUPERIOR_PERNA_ESQUERDA':
      return 'Externa do terço superior da perna esquerda'
    case 'EXTERNA_TERCO_MEDIO_PERNA_ESQUERDA':
      return 'Externa do terço médio da perna esquerda'
    case 'EXTERNA_JOELHO_ESQUERDO':
      return 'Externa do joelho esquerdo'
    case 'EXTERNA_TERCO_INFERIOR_COXA_ESQUERDA':
      return 'Externa do terço inferior da coxa esquerda'
    case 'EXTERNA_TERCO_MEDIO_COXA_ESQUERDA':
      return 'Externa do terço médio da coxa esquerda'
    case 'EXTERNA_TERCO_SUPERIOR_COXA_ESQUERDA':
      return 'Externa do terço superior da coxa esquerda'
    case 'QUADRIL_ESQUERDA':
      return 'Quadril esquerda'
    case 'LATERAL_PESCOCO_DIREITA':
      return 'Lateral direita do pescoço'
    case 'ESCAPULO_UMERAL_DIREITO':
      return 'Escápulo-umeral direita'
    case 'PALMAR_MAO_DIREITA':
      return 'Palmar da mão direita'
    case 'EXTERNA_PUNHO_DIREITO':
      return 'Externa do punho direito'
    case 'EXTERNA_TERCO_INFERIOR_ANTEBRACO_DIREITO':
      return 'Externa do terço inferior do antebraço direito'
    case 'EXTERNA_TERCO_MEDIO_ANTEBRACO_DIREITO':
      return 'Externa do terço médio do antebraço direito'
    case 'EXTERNA_TERCO_SUPERIOR_ANTEBRACO_DIREITO':
      return 'Externa do terço superior do antebraço direito'
    case 'EXTERNA_COTOVELO_DIREITO':
      return 'Externa do cotovelo direito'
    case 'EXTERNA_TERCO_INFERIOR_BRACO_DIREITO':
      return 'Externa do terço inferior do braço direito'
    case 'EXTERNA_TERCO_MEDIO_BRACO_DIREITO':
      return 'Externa do terço médio do braço direito'
    case 'EXTERNA_TERCO_SUPERIOR_BRACO_DIREITO':
      return 'Externa do terço superior do braço direito'
    case 'LATERAL_EXTERNA_PE_DIREITO':
      return 'Lateral externa do pé direito'
    case 'MALEOLAR_DIREITA':
      return 'Maleolar direita'
    case 'EXTERNA_TERCO_INFERIOR_PERNA_DIREITA':
      return 'Externa do terço inferior da perna direita'
    case 'EXTERNA_TERCO_SUPERIOR_PERNA_DIREITA':
      return 'Externa do terço superior da perna direita'
    case 'EXTERNA_TERCO_MEDIO_PERNA_DIREITA':
      return 'Externa do terço médio da perna direita'
    case 'EXTERNA_JOELHO_DIREITO':
      return 'Externa do joelho direito'
    case 'EXTERNA_TERCO_INFERIOR_COXA_DIREITA':
      return 'Externa do terço inferior da coxa direita'
    case 'EXTERNA_TERCO_MEDIO_COXA_DIREITA':
      return 'Externa do terço médio da coxa direita'
    case 'EXTERNA_TERCO_SUPERIOR_COXA_DIREITA':
      return 'Externa do terço superior da coxa direita'
    case 'QUADRIL_DIREITA':
      return 'Quadril direita'
    case 'GLUTEA_DIREITA':
      return 'Glútea direita'
    case 'CERVICAL_ESQUERDA':
      return 'Cervical esquerda'
    case 'CERVICAL_DIREITA':
      return 'Cervical direita'
    case 'CAROTIDIANA_DIREITA_EXTERNA':
      return 'Carotidiana direita'
    case 'CAROTIDIANA_ESQUERDA_EXTERNA':
      return 'Carotidiana esquerda'
    case 'PARIETAL_ESQUERDA_POSTERIOR':
      return 'Parietal esquerda posterior'
    case 'PARIETAL_DIREITA_POSTERIOR':
      return 'Parietal direita posterior'
    case 'PARIETAL_DIREITA_EXTERNA':
      return 'Parietal direita'
    case 'TEMPORAL_ESQUERDA_POSTERIOR':
      return 'Temporal esquerda posterior'
    case 'TEMPORAL_DIREITA_POSTERIOR':
      return 'Temporal direita posterior'
    case 'TEMPORAL_ESQUERDA_EXTERNA':
      return 'Temporal esquerda'
    case 'TEMPORAL_DIREITA_EXTERNA':
      return 'Temporal direita'
    case 'AURICULAR_ESQUERDA_POSTERIOR':
      return 'Auricular esquerda posterior'
    case 'AURICULAR_DIREITA_POSTERIOR':
      return 'Auricular direita posterior'
    case 'AURICULAR_ESQUERDA_EXTERNA':
      return 'Auricular esquerda'
    case 'AURICULAR_DIREITA_EXTERNA':
      return 'Auricular direita'
    case 'FRONTAL_ESQUERDA':
      return 'Frontal esquerda'
    case 'FRONTAL_DIREITA':
      return 'Frontal direita'
    case 'OCCIPITAL_ESQUERDA':
      return 'Occipital esquerda'
    case 'OCCIPITAL_DIREITA':
      return 'Occipital direita'
    case 'INFRA_HIOIDIANA_ESQUERDA':
      return 'Infra-hioidiana esquerda'
    case 'INFRA_HIOIDIANA_DIREITA':
      return 'Infra-hioidiana direita'
    case 'SUPRA_HIOIDIANA_ESQUERDA':
      return 'Supra-hioidiana esquerda'
    case 'SUPRA_HIOIDIANA_DIREITA':
      return 'Supra-hioidiana direita'
    case 'MASSETERIANA_ESQUERDA_EXTERNA':
      return 'Masseteriana esquerda'
    case 'MASSETERIANA_DIREITA_EXTERNA':
      return 'Masseteriana direita'
    case 'BUCINADORA_ESQUERDA_EXTERNA':
      return 'Bucinadora esquerda'
    case 'BUCINADORA_DIREITA_EXTERNA':
      return 'Bucinadora direita'
    case 'MENTONIANA_ESQUERDA':
      return 'Mentoniana esquerda'
    case 'MENTONIANA_DIREITA':
      return 'Mentoniana direita'
    case 'LABIAL_ESQUERDA':
      return 'Labial esquerda'
    case 'LABIAL_DIREITA':
      return 'Labial direita'
    case 'NASAL_ESQUERDA':
      return 'Nasal esquerda'
    case 'NASAL_DIREITA':
      return 'Nasal direita'
    case 'MALAR_ESQUERDA_EXTERNA':
      return 'Malar esquerda'
    case 'MALAR_DIREITA_EXTERNA':
      return 'Malar direita'
    case 'ZIGOMATICA_ESQUERDA_EXTERNA':
      return 'Zigomática esquerda'
    case 'ZIGOMATICA_DIREITA_EXTERNA':
      return 'Zigomática direita'
    case 'ORBITAL_ESQUERDA_EXTERNA':
      return 'Orbital esquerda'
    case 'ORBITAL_DIREITA_EXTERNA':
      return 'Orbital direita'
    case 'ESTERNAL_ESQUERDA':
      return 'Esternal esquerda'
    case 'ESTERNAL_DIREITA':
      return 'Esternal direita'
    case 'LATERAL_COTOVELO_DIREITO':
      return 'Lateral do cotovelo direito'
    case 'LATERAL_COTOVELO_ESQUERDO':
      return 'Lateral do cotovelo esquerdo'
    case 'COTOVELO_DIREITO_EXTERNA':
      return 'Cotovelo direito'
    case 'COTOVELO_ESQUERDO_EXTERNA':
      return 'Cotovelo esquerdo'
    case 'DELTOIDIANA_DIREITA_EXTERNA':
      return 'Deltoidiana direita'
    case 'DELTOIDIANA_ESQUERDA_EXTERNA':
      return 'Deltoidiana esquerda'
    case 'CLAVICULAR_DIREITA_EXTERNA':
      return 'Clavicular direita'
    case 'CLAVICULAR_ESQUERDA_EXTERNA':
      return 'Clavicular esquerda'
    case 'INFRACLAVICULAR_DIREITA_EXTERNA':
      return 'Infraclavicular direita'
    case 'INFRACLAVICULAR_ESQUERDA_EXTERNA':
      return 'Infraclavicular esquerda'
    case 'FOSSA_ILIACA_DIREITA_EXTERNA':
      return 'Fossa ilíaca direita'
    case 'FOSSA_ILIACA_ESQUERDA_EXTERNA':
      return 'Fossa ilíaca esquerda'
    case 'HIPOGASTRICA_DIREITA':
      return 'Hipogástrica direita'
    case 'HIPOGASTRICA_ESQUERDA':
      return 'Hipogástrica esquerda'
    case 'FLANCO_DIREITO_EXTERNO':
      return 'Flanco direito'
    case 'FLANCO_ESQUERDO_EXTERNO':
      return 'Flanco esquerdo'
    case 'UMBILICAL_DIREITA':
      return 'Umbilical direita'
    case 'UMBILICAL_ESQUERDA':
      return 'Umbilical esquerda'
    case 'MESOGASTRICA_DIREITA':
      return 'Mesogástrica direita'
    case 'MESOGASTRICA_ESQUERDA':
      return 'Mesogástrica esquerda'
    case 'EPIGASTRICA_DIREITA':
      return 'Epigástrica direita'
    case 'EPIGASTRICA_ESQUERDA':
      return 'Epigástrica esquerda'
    case 'INGUINAL_DIREITA_EXTERNA':
      return 'Inguinal direita'
    case 'INGUINAL_ESQUERDA_EXTERNA':
      return 'Inguinal esquerda'
    case 'PUBIANA_DIREITA':
      return 'Pubiana direita'
    case 'PUBIANA_ESQUERDA':
      return 'Pubiana esquerda'
    case 'CRURAL_DIREITA_EXTERNA':
      return 'Crural direita'
    case 'CRURAL_ESQUERDA_EXTERNA':
      return 'Crural esquerda'
    case 'GLUTEA_DIREITA_EXTERNA':
      return 'Glútea direita'
    case 'GLUTEA_ESQUERDA_EXTERNA':
      return 'Glútea esquerda'
    case 'POPLITEA_DIREITA_EXTERNA':
      return 'Poplítea direita'
    case 'POPLITEA_ESQUERDA_EXTERNA':
      return 'Poplítea esquerda'
    case 'DORSAL_PE_DIREITO_EXTERNO':
      return 'Dorsal do pé direito'
    case 'DORSAL_PE_ESQUERDO_EXTERNO':
      return 'Dorsal do pé esquerdo'
    case 'CALCANEANA_ESQUERDA_EXTERNA':
      return 'Calcaneana esquerda'
    case 'CALCANEANA_DIREITA_EXTERNA':
      return 'Calcaneana direita'
    case 'DORSAL_MAO_DIREITA_EXTERNA':
      return 'Dorsal da mão direita'
    case 'DORSAL_MAO_ESQUERDA_EXTERNA':
      return 'Dorsal da mão esquerda'
    case 'PRIMEIRO_QUIRODACTILO_DIREITO_EXTERNA':
      return 'Primeiro quirodactilo direito'
    case 'PRIMEIRO_QUIRODACTILO_ESQUERDO_EXTERNA':
      return 'Primeiro quirodactilo esquerdo'
    case 'QUINTO_PEDODACTILO_DIREITO_EXTERNO':
      return 'Quinto pedodactilo direito'
    case 'QUINTO_PEDODACTILO_ESQUERDO_EXTERNO':
      return 'Quinto pedodactilo esquerdo'
    case 'QUARTO_PEDODACTILO_DIREITO_EXTERNO':
      return 'Quarto pedodactilo direito'
    case 'QUARTO_PEDODACTILO_ESQUERDO_EXTERNO':
      return 'Quarto pedodactilo esquerdo'
    case 'TERCEIRO_PEDODACTILO_DIREITO_EXTERNO':
      return 'Terceiro pedodactilo direito'
    case 'TERCEIRO_PEDODACTILO_ESQUERDO_EXTERNO':
      return 'Terceiro pedodactilo esquerdo'
    case 'SEGUNDO_PEDODACTILO_DIREITO_EXTERNO':
      return 'Segundo pedodactilo direito'
    case 'SEGUNDO_PEDODACTILO_ESQUERDO_EXTERNO':
      return 'Segundo pedodactilo esquerdo'
    case 'PRIMEIRO_PEDODACTILO_DIREITO_EXTERNO':
      return 'Primeiro pedodactilo direito'
    case 'PRIMEIRO_PEDODACTILO_ESQUERDO_EXTERNO':
      return 'Primeiro pedodactilo esquerdo'
    default:
      return regiao
  }
}

export const getLabelTipoVestigioFixado = (rowData) => {
  if (!rowData.tipo.cod) {
    return ''
  }
  if (rowData.tipo.cod.toLowerCase() === 'outro') {
    return rowData.tipoInputText
  }
  return rowData.tipo.nome
}

export const getPopularesLabel = (value) => {
  if (value === 'PRESENTES - FORA DA ZONA') return 'POPULARES FORA DA ZONA DE VESTÍGIOS'
  if (value === 'PRESENTES - DENTRO DA ZONA') return 'POPULARES DENTRO DA ZONA DE VESTÍGIOS'
  if (value === 'SEM POPULARES') return 'QUANTIDADE INSIGNIFICATIVA DE POPULARES NO LOCAL'
  return ''
}

export const getClassificacaoLocalLabel = (value) => {
  if (value === 'IMEDIATO') return 'LOCAL IMEDIATO'
  if (value === 'RELACIONADO') return 'LOCAL RELACIONADO'
  return ''
}

export const getRotuloTipoExameSolicitado = (tipoExame) => {
  switch (tipoExame) {
    case constants.TIPOS_EXAMES.ACHADO_CADAVER:
      return { color: '#FF0000', sigla: 'AC' }
    case constants.TIPOS_EXAMES.NECROSCOPICO:
      return { color: '#00FF00', sigla: 'NC' }
    case constants.TIPOS_EXAMES.EFICIENCIA_BALISTICA:
      return { color: '#0000FF', sigla: 'EB' }
    case constants.TIPOS_EXAMES.CONFRONTO_BALISTICO:
      return { color: '#0000FF', sigla: 'CB' }
    case constants.TIPOS_EXAMES.IDENTIFICACAO_BALISTICA:
      return { color: '#0000FF', sigla: 'IB' }
    default:
      return { color: '#FFFFFF', sigla: 'UN' }
  }
}

export const getLabelTipoExameRealizado = (tipo) => {
  switch (tipo) {
    case 'EFICIENCIA_BALISTICA':
      return 'Eficiência Balística'
    case 'IDENTIFICACAO_BALISTICA':
      return 'Identificação Balística'
    case 'CONFRONTO_BALISTICO':
      return 'Confronto Balístico'
    case 'NECROSCOPICO':
      return 'Necroscópico'
    case 'PESQUISA_SANGUE_HUMANO':
      return 'Pesquisa de sangue humano'
    case 'CONSTATACAO':
      return 'Constatação'
    case 'QUIMICO_TOXICOLOGICO':
      return 'Químico-Toxicológico'
    case 'DOSAGEM_ALCOOLICA':
      return 'Dosagem alcóolica'
    case 'IDENTIFICACAO_VEICULAR':
      return 'Identificação veicular'
    case 'VEICULAR':
      return 'Veicular'
    case 'TOXICOLOGICO_POST_MORTEM_DAF':
      return 'Toxicológico post mortem DAF'
    case 'TOXICOLOGICO_POST_MORTEM_PEST':
      return 'Toxicológico post mortem PEST'
    case 'TOXICOLOGICO_IN_VIVO':
      return 'Toxicológico in vivo'
    case 'CONJUNCAO_CARNAL':
      return 'Conjunção carnalz'
    case 'ATO_LIBIDINOSO':
      return 'Ato libidinoso'
    case 'PSICOLOGICA':
      return 'Psicologia'
    case 'LESAO_CORPORAL':
      return 'Lesão corporal'
    case 'ACHADO_CADAVER':
      return 'Crime contra a vida'
    case 'IMOVEL':
      return 'Imóvel'
    case 'TRAFEGO':
      return 'Acidente de Tráfego'
    case 'ESPERMATOSOIDE_PSA':
      return 'Espermatosoide PSA'
    case 'RESIDUOGRAFICO':
      return 'Residuográfico'
    case 'DNA':
      return 'DNA'
    case 'QUIMICO_VOLATEIS':
      return 'Químico Voláteis'
    case 'QUIMICO_ANABOLIZANTES':
      return 'Químico Anabolizantes'
    case 'QUIMICO_OUTRAS_SUBSTANCIAS':
      return 'Químico outras substâncias'
    case 'DOCUMENTOSCOPICO':
      return 'Documentoscópico'
    case 'OBJETO':
      return 'Objeto'
    case 'COMPLEMENTAR':
      return 'Complementar'
    case 'PAPILOSCOPICO':
      return 'Papiloscópico'
    case 'CONFRONTO_PAPILOSCOPICO':
      return 'Confronto papiloscópico'
    case 'GRAFOTÉCNICO':
      return 'Grafotécnico'
    case 'ANTROPOLOGICO':
      return 'Antropológico'
    case 'AMBIENTAL':
      return 'Ambiental'
    case 'MERCEOLOGICO':
      return 'Merceológico'
    case 'INFORMATICA':
      return 'Informática'
    case 'INCENDIO':
      return 'Incêndio'
    case 'AUDIO_VISUAL':
      return 'Audiovisual'
    case 'CONTABIL':
      return 'Contábil'
    case 'ENGENHARIA_LEGAL':
      return 'Engenharia legal'
    case 'CORPO_ESTRANHO':
      return 'Corpo estranho'
    case 'GRAVIDEZ':
      return 'Gravidez'
    case 'CLASSIFICACAO':
      return 'Classificação'
    case 'NECROPAPILOSCOPIA':
      return 'Necropapiloscopia'
    case 'PESQUISA_THC_COCAINA':
      return 'Químico para Pesquisa de THC e/ou Cocaína'
    case 'QUIMICO_PESQUISA_AGROTOXICOS':
      return 'Químico para Pesquisa de Agrotóxicos'
    case 'QUIMICO_PESQUISA_SOLVENTES':
      return 'QUIMICO_PESQUISA_SOLVENTES'
    case 'QUIMICO_PRODUTO_FARMACEUTICO':
      return 'Químico em Produto Farmacêutico'
    case 'QUIMICO_PESQUISA_INFLAMAVEIS':
      return 'Químico para Pesquisa de Combustíveis e/ou Inflamáveis'

    default:
      return tipo
  }
}

export const getLabelRestricao = (restricao) => {
  switch (restricao) {
    case 'REST1':
      return `Esse tipo de exame deve ser realizado sobre vestígios extraídos de cadáveres. A lista de opções exibirá apenas vestígios do caso que foram extraídos de cadáveres`
    case 'REST2':
      return 'Esse tipo de exame só pode ser realizado sobre vestígios do tipo Sangue ou Humor Vítreo'
    case 'REST3':
      return 'Esse tipo de exame só pode ser realizado sobre vestígios do tipo Sangue, Conteúdo Estomacal, Humor Vítreo, Urina ou Fígado'
    case 'REST4':
      return 'Esse tipo de exame só pode ser realizado sobre vestígios do tipo Conteúdo Estomacal, Urina ou Sangue'
    case 'REST5':
      return 'Esse tipo de exame só pode ser realizado sobre vestígios do tipo Sangue, Humor Vítreo ou Pulmão'
    default:
      return ''
  }
}

export const getLabelTipoVestigioEspecifico = (identificador) => {
  switch (identificador) {
    case 'ARMA_DE_FOGO':
      return 'Arma de fogo'
    case 'MUNICAO':
      return 'Munição'
    case 'ELEMENTO_MUNICAO':
      return 'Elemento de munição'
    case 'CARTUCHO':
      return 'Cartucho de munição'
    case 'ESTOJO':
      return 'Estojo'
    case 'ELEMENTO_RECARGA':
      return 'Elemento de recarga'
    case 'CARREGADOR':
      return 'Carregador'
    case 'ARTEFATO':
      return 'Artefato'
    case 'ARMA_DE_PRESSAO':
      return 'Arma de pressão'
    case 'PADRAO':
      return 'Padrão balístico'
    case 'SIMULACRO':
      return 'Simulacro'
    case 'OBJETO':
      return 'Objeto'
    case 'VESTUARIO':
      return 'Vestuário'
    case 'SUABE':
      return 'Suabe'
    case 'PO':
      return 'Pó'
    case 'ERVA':
      return 'Erva'
    case 'SEMENTE':
      return 'Semente'
    case 'PLANTA':
      return 'Planta'
    case 'CIGARRO':
      return 'Cigarro'
    case 'PEDRA':
      return 'Pedra'
    case 'SELO':
      return 'Selo'
    case 'LIQUIDO':
      return 'Líquido'
    case 'COMPRIMIDO':
      return 'Comprimido'
    case 'LIQUIDO_FARMACO':
      return 'Líquido farmaco'
    case 'LIQUIDO_COMBUSTIVEL':
      return 'Líquido combustível'
    case 'RESIDUO_DE_INCENDIO':
      return 'Resíduo de incêndio'
    case 'COQUETEL_MOLOTOV':
      return 'Coquetel molotov'
    case 'CAPSULA':
      return 'Cápsula'
    case 'SUPORTE':
      return 'Suporte'
    case 'FACA':
      return 'Faca'
    case 'CARTA':
      return 'Carta'
    case 'DOCUMENTO':
      return 'Documento'
    case 'CELULAR':
      return 'Celular'
    case 'DISPOSITIVO_ARMAZENAMENTO':
      return 'Dispositivo de armazenamento'
    case 'COMPUTADOR':
      return 'Computador'
    case 'LAPTOP':
      return 'Laptop'
    case 'SWITCH':
      return 'Switch'
    case 'MODEM':
      return 'Modem'
    case 'CAMERA':
      return 'Câmera'
    case 'CACA-NIQUEL':
      return 'Caça-níquel'
    case 'DECALQUE':
      return 'Decalque'
    case 'OUTRO':
      return 'Outro'

    default:
      return identificador
  }
}

export const getLabelStatusSolicitacaoVestigio = (status) => {
  switch (status) {
    case 'PENDENTE':
      return 'Pendente'
    case 'CANCELADA':
      return 'Cancelada'
    case 'ATENDIDA':
      return 'Atendida'
    case 'RECUSADA':
      return 'Recusada'
    case 'EM_SEPARACAO':
      return 'Em separação'
    case 'PRONTA_PARA_COLETA':
      return 'Pronta para coleta'
    default:
      return status
  }
}